module.exports = __webpack_public_path__ + "static/media/servebolt.0b1c4435.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/servebolt.webp
// module id = 741
// module chunks = 0